export default "__VITE_ASSET__DKTaznmP__"